@if (account !== null) {
  <div>
    <div class="savings__sepa_wrapper">
      <label>{{ getFieldName(getUserNameField()) | translate }}</label>
      <bp-input type="text" [value]="getUserNameField().value" [readonly]="true" [disabled]="true" [tabIndex]="-1">
      </bp-input>
      <label>{{ getFieldName(getBankIbanField()) | translate }}</label>
      <bp-input
        type="text"
        [(value)]="getBankIbanField().value"
        [tabIndex]="0"
        (valueChange)="copyPasteValidation($event)"
        (onFocusOut)="onInputFocusOut($event, getBankIbanField())"
      [error]="getValidationError(getBankIbanField().getName()) | translate"></bp-input>
      @if (showBankDataField()) {
        <div class="savings__bank_detail_field">
          @for (field of getBankDataFields(); track field) {
            <div>
              @if (needsBicTag(field)) {
                <span>{{ "bic_tx_item" | translate }}:</span>
              }
              {{ " " + field?.getValue() }}
            </div>
          }
        </div>
      }
      @if (!isSepaSupported()) {
        <div class="not-supported">{{ "bank_account_sepa_not_supported" | translate }}</div>
        <button class="btn btn-primary btn-lg btn-block" (click)="backToProviders()">
          {{ "choose_payment_provider_button" | translate }}
        </button>
      }
    </div>
    <hr class="mt-0 mb-0" />
    <div class="bp-modal-body-section pt-30">
      <button class="btn btn-primary btn-lg btn-block" [disabled]="isAccountValidated" (click)="createSepaAccount()">
        {{ "verification_save_and_continue_button" | translate }}
      </button>
    </div>
  </div>
}
